import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import $ from 'jquery';
import * as PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import getTestProps from 'test/lib/cypress/getTestProps';
import {Optional} from 'util/Types';

import {BLUE} from './Colors';

export interface IndeterminateCheckboxProps<T> {
  className?: Optional<string>;
  disabled: boolean;
  items: Array<T>;
  disabledMap?: (item: T) => boolean;
  selectedMap: (item: T) => boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export const INDETERMINATE_CHECKBOX_PROPS = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  disabledMap: PropTypes.func,
  selectedMap: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class IndeterminateCheckbox<T> extends React.Component<IndeterminateCheckboxProps<T>> {
  static propTypes = INDETERMINATE_CHECKBOX_PROPS;
  static defaultProps = {disabled: false};

  componentDidMount(): void {
    this.syncIndeterminate();
  }

  componentDidUpdate(): void {
    this.syncIndeterminate();
  }

  everySelected(): boolean {
    // filter out disabled rows in order to enable checking all editable boxes
    return this.props.items
      .filter((item) => this.props.disabledMap == null || !this.props.disabledMap(item))
      .every((item) => this.props.selectedMap(item));
  }

  someSelected(): boolean {
    // filter out disabled rows in order to enable unchecking all editable boxes
    return this.props.items
      .filter((item) => this.props.disabledMap == null || !this.props.disabledMap(item))
      .some((item) => this.props.selectedMap(item));
  }

  syncIndeterminate(): void {
    const indeterminate = !this.everySelected() && this.someSelected();
    $(ReactDOM.findDOMNode(this)!).prop({indeterminate});
  }

  render(): JSX.Element {
    return (
      <input
        checked={this.someSelected()}
        className={classNames(this.props.className, css(styles.checkbox))}
        disabled={this.props.disabled}
        type="checkbox"
        onChange={this.props.onChange}
        {...getTestProps({component: 'IndeterminateCheckbox', element: 'root'})}
      />
    );
  }
}

const styles = StyleSheet.create({
  checkbox: {
    accentColor: BLUE,
  },
});

export default IndeterminateCheckbox;
